import React from "react";

import {
  StepStatus,
  PersonalAutoStep,
  PersonalAutoQuickStep,
  HomeownerQuickStep,
  HomeownerStep
} from "../types/enums";
import { Progress } from ".";
import { ProgressStepType } from "./Progress";
import {
  PERSONAL_AUTO_STEPS,
  PERSONAL_AUTO_QUICK_STEPS,
  HOMEOWNER_QUICK_STEPS,
  HOMEOWNER_STEPS
} from "../constants/progressBarContants";

type StepType =
  | PersonalAutoQuickStep
  | PersonalAutoStep
  | HomeownerQuickStep
  | HomeownerStep;

export type ProgressBarStepType = {
  step: StepType;
  icon: string;
  title: string;
  route: string;
};

const stepStatus = (step: StepType, activeStep: StepType): StepStatus => {
  if (step === activeStep) return StepStatus.ACTIVE;
  if (step < activeStep) return StepStatus.COMPLETE;
  return StepStatus.PENDING;
};

export const PersonalAutoProgress = (props: {
  activeStep: PersonalAutoStep;
}) => {
  return (
    <ProgressBar activeStep={props.activeStep} allSteps={PERSONAL_AUTO_STEPS} />
  );
};

export const PersonalAutoQuickProgress = (props: {
  activeStep: PersonalAutoQuickStep;
}) => {
  return (
    <ProgressBar
      activeStep={props.activeStep}
      allSteps={PERSONAL_AUTO_QUICK_STEPS}
    />
  );
};

export const HomeownersProgress = (props: { activeStep: HomeownerStep }) => {
  return (
    <ProgressBar activeStep={props.activeStep} allSteps={HOMEOWNER_STEPS} />
  );
};

export const HomeownersQuickProgress = (props: {
  activeStep: HomeownerQuickStep;
}) => {
  return (
    <ProgressBar
      activeStep={props.activeStep}
      allSteps={HOMEOWNER_QUICK_STEPS}
    />
  );
};

const ProgressBar = (props: {
  activeStep: StepType;
  allSteps: ProgressBarStepType[];
}) => {
  const { activeStep, allSteps } = props;
  const personalAutoSteps = allSteps.reduce(
    (steps, currentStep: ProgressBarStepType) => {
      const { step, ...rest } = currentStep;
      steps.push({
        ...rest,
        status: stepStatus(step, activeStep)
      });
      return steps;
    },
    [] as ProgressStepType[]
  );

  return <Progress steps={personalAutoSteps} />;
};
